
import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Firebase, Auth } from '../../../../Core'
import * as actions from '../phase0.actions'
import * as audioActions from '../../../../Core/Game/AudioContainer/audio.actions'
import { bindActionCreators } from 'redux'
import FederationFlag from '../../../Components/FederationFlag'
import * as storyLineSelectors from '../../../../Core/StoryLine/storyLine.selectors'

class SelectFederation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedFederation: '',
    }
  }

  continue() {
    const { next, addHowlSound } = this.props
    next()
    addHowlSound('button_click_icon')
  }

  saveFederation() {
    const { saveSelectedFederation } = this.props
    const { selectedFederation } = this.state
    saveSelectedFederation(selectedFederation)
  }

  handleChange(federationName) {
    // TODO delete
    if (this.federationName) {
      this.setState({ selectedFederation: federationName })
      return
    }

    this.setState({ selectedFederation: federationName }, () => {
      this.saveFederation()
    })
  }

  renderFederation(federation) {
    const { federationFlags } = this.props

    // TODO set class for selected federation
    const federationClass =
      this.state.selectedFederation === federation.name ? 'settings--federations__selected' : ''

    return (
      <div
        onClick={() => this.handleChange(federation.name)}
        className={'settings--federations__item ' + federationClass}
      >
        <FederationFlag flag={federationFlags[federation.name]} />
        <div className="settings--federations__name">{federation.name}</div>
      </div>
    )
  }

  render() {
    const { federationsInfo, playerListData } = this.props

    const disabled = !(playerListData && playerListData.federationId)

    return (
      <div className="container background background--challenge">
        <div className="content">
          <div className="settings">
            <div className="settings--content ">
              <div className="settings--title">
                <FormattedMessage id={'phase.selectFederation'} />
              </div>
              <div className="settings--federations__message">
                <span className="icon-info"></span>
                <FormattedMessage id={'phase.messageFederation'} />
              </div>
              <div className="settings--federations">
                {Object.keys(federationsInfo.federations).map((fed) =>
                  this.renderFederation(federationsInfo.federations[fed])
                )}
              </div>
              <div className="settings--buttons">
                <div
                  onClick={() => !disabled && this.continue()}
                  className={'btn--orange ' + (disabled ? 'disabled' : '')}
                >
                  <span className="icon-rocket"></span>
                  <span>
                    <FormattedMessage id={'phase.begin'} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    federationsInfo: Firebase.selectors.getFederationsInfo(state),
    user: Auth.selectors.getUserInfo(state),
    playerListData: Firebase.selectors.getUserDataShield(state),
    federationFlags: storyLineSelectors.getFederationsFlags(state),
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    saveSelectedFederation: bindActionCreators(actions.saveSelectedFederation, dispatch),
  }
}
SelectFederation.propTypes = {
  federationsInfo: PropTypes.object,
  saveSelectedFederation: PropTypes.func,
  user: PropTypes.object,
  next: PropTypes.func,
  addHowlSound: PropTypes.func,
  playerListData: PropTypes.object,
  federationFlags: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectFederation)
